import React, {Suspense, lazy} from 'react'
import {Redirect, Route, Switch} from 'react-router-dom'
import {FallbackView} from '../../../_metronic/partials'
import {AdminPortalLayout} from './AdminPortalLayout'
import PostCodeMatrix from './pages/LookUpTables/PostCodeMatrix/PostCodeMatrix'
import Product from './pages/Products/Products'
import ProductDetailsPage from './pages/Products/ProductDetailsPage'
import {useHistory} from 'react-router-dom'
import {AdminContextProvider} from '../../context/AdminContext'
import { AdminOrderSummaryContextProvider } from '../../context/AdminOrderSummaryContext'
import { UserModel } from '../../modules/auth/models/UserModel'
import { shallowEqual, useSelector } from 'react-redux'
import { RootState } from '../../../setup'
import { USER_TYPES } from '../../../utils'

export function AdminRoutes() {
  let user: UserModel = useSelector<RootState>(({auth}) => auth.user, shallowEqual) as UserModel

  const isAdminUser = user?.userRoles?.includes(USER_TYPES.ADMIN)
  const PriceBook = lazy<React.FC>(() => import('./pages/PriceBooks/PriceBooks'))
  const LookUpTable = lazy<React.FC>(() => import('./pages/LookUpTables/LookUpTables'))
  const Regions = lazy<React.FC>(() => import('./pages/LookUpTables/Regions/Regions'))
  const Orders = lazy<React.FC>(() => import('./pages/Orders/Orders'))
  const Colours = lazy<React.FC>(() => import('./pages/Colours/Colours'))
  const OrderDetails = lazy<React.FC>(
    () => import('./pages/Orders/OrderDetailsPage/OrderDetailsPage')
  )
  const TopographicalClassificationMatrix = lazy<React.FC>(
    () =>
      import(
        './pages/LookUpTables/TopographicalClassificationMatrix/TopographicalClassificationMatrix'
      )
  )
  const WindClassification = lazy<React.FC>(
    () => import('./pages/LookUpTables/WindClassification/WindClassification')
  )
  const SpanMatrix = lazy<React.FC>(() => import('./pages/LookUpTables/SpanMatrix/SpanMatrix'))
  const LoadCapacityMatrix = lazy<React.FC>(
    () => import('./pages/LookUpTables/LoadCapacityMatrix/LoadCapacityMatrix')
  )
  const BeamUpliftLoadsMatrix = lazy<React.FC>(
    () => import('./pages/LookUpTables/BeamUpliftLoadsMatrix/BeamUpliftLoadsMatrix')
  )

  const history = useHistory()

  return (
    <AdminPortalLayout>
      <Suspense fallback={<FallbackView />}>
        <AdminContextProvider>
          <Switch>
            <Route exact path='/admin/orders' render={() => <Orders />} />
            <Route exact path='/admin/orders/:id' render={() => 
              <AdminOrderSummaryContextProvider>
                <OrderDetails />
              </AdminOrderSummaryContextProvider>
            } />

            {isAdminUser && <Route exact path='/admin/lookup-tables' render={() => <LookUpTable />} />}
            {isAdminUser && <Route exact path='/admin/products' render={() => <Product />} />}
            {isAdminUser && <Route
              exact
              path='/admin/product-details/:productType/:productId'
              render={(props) => (
                <ProductDetailsPage
                  productType={props.match.params.productType}
                  productId={props.match.params.productId}
                  onClose={() => history.push('/admin/products')}
                />
              )}
            />}
            {isAdminUser && <Route
              exact
              path='/admin/lookup-tables/post-code-matrix'
              render={() => <PostCodeMatrix />}
            />}
            {isAdminUser && <Route exact path='/admin/lookup-tables/regions' render={() => <Regions />} />}
            {isAdminUser && <Route
              exact
              path='/admin/lookup-tables/topographical-classification-matrix'
              render={() => <TopographicalClassificationMatrix />}
            />}
            {isAdminUser && <Route
              exact
              path='/admin/lookup-tables/wind-classification'
              render={() => <WindClassification />}
            />}
            {isAdminUser && <Route exact path='/admin/lookup-tables/span-matrix' render={() => <SpanMatrix />} />}
            {isAdminUser && <Route
              exact
              path='/admin/lookup-tables/load-capacity-matrix'
              render={() => <LoadCapacityMatrix />}
            />}
            {isAdminUser && <Route
              exact
              path='/admin/lookup-tables/beam-uplift-loads-matrix'
              render={() => <BeamUpliftLoadsMatrix />}
            />}
            {isAdminUser && <Route
              exact
              path='/admin/colours'
              render={() => <Colours />}
            />}
            <Redirect to='/admin/orders' />
          </Switch>
        </AdminContextProvider>
      </Suspense>
    </AdminPortalLayout>
  )
}
